import moment from 'moment';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '../../pipes/translate.pipe';
import { DirectoryService } from '../../services/directory.service';
import { OverlayService } from '../../services/overlayService';
import { isTimestamp } from '../../services/is-timestamp.util';

@Component({
  selector: 'mtm-asset-name',
  templateUrl: './asset-name.component.html',
  styleUrl: './asset-name.component.scss',
  standalone: false,
})
export class MtmAssetNameComponent implements OnInit {
  @Input() projectId: string;
  @Input() file: any;
  @Input() nameAttribute: string;
  @Input() allowFilenameEdit: boolean;

  @Output() nameClick: EventEmitter<any> = new EventEmitter<any>();

  editMode: boolean = false;
  fileName: string;
  fileExtension: string;

  constructor(
    private readonly overlayService: OverlayService,
    private readonly translatePipe: TranslatePipe,
    private readonly directoryService: DirectoryService
  ) {}

  ngOnInit(): void {
    if (!this.file) {
      return;
    }
    this.file.printName =
      this.file.displayName || this.file.name || this.file.title || this.file.fileProperties.fileName;
  }

  saveName() {
    this.editMode = false;
    const newFilename = this.fileName + '_' + moment().unix() + this.fileExtension;
    this.file.displayName = this.file.name = this.file.title = this.file.printName = newFilename;
    this.directoryService.renameFolder(this.projectId || this.file.projectId, this.file.id, newFilename).subscribe({
      next: (res: any) => {
        this.overlayService.showSuccess(this.translatePipe.transform('overlayChangeSave'), 'Success');
      },
      error: (err) => {
        this.overlayService.showError(err.message, 'Error');
      },
    });
  }

  handleNameClick() {
    if (this.allowFilenameEdit) {
      this.editMode = !this.editMode;
      this.fileName = this.getDisplay(this.file.displayName).split('.').slice(0, -1).join('.');
    } else {
      this.nameClick.emit(this.file);
    }
  }

  getDisplay(name: any) {
    if (!name) {
      return '';
    }
    const ext = name.split('.').length > 1 ? name.split('.').pop() : '';
    const nameArr = name.split('_');
    const isTime = isTimestamp(nameArr.pop().split('.')[0]);
    let savedName = '';
    if (isTime) {
      savedName = nameArr.length
        ? nameArr.slice(0, nameArr.length - 1 >= 0 ? nameArr.length : 0).join('_')
        : name.split('.')[0];
    } else {
      const nameSplit = name.split('.');
      savedName = nameSplit.slice(0, nameSplit.length - 1 > 0 ? nameSplit.length - 1 : 1).join('.');
    }
    const fileDisplayName = savedName.replace(/[^a-zA-Z0-9-] /g, '_') + (ext && ext !== 'undefined' ? '.' + ext : '');
    this.fileExtension = '.' + fileDisplayName.split('.')[1];
    return fileDisplayName;
  }
}
